import React from 'react';

const GamingHeroSection = () => {
    // Gaming-themed image data
    // const leftColumnImages = [
    //     { id: 1, src: 'https://images.unsplash.com/photo-1542751371-adc38448a05e', alt: 'Esports' },
    //     { id: 2, src: 'https://images.unsplash.com/photo-1493711662062-fa541adb3fc8', alt: 'Console' },
    //     { id: 3, src: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd', alt: 'VR' },
    //     { id: 4, src: 'https://images.unsplash.com/photo-1511512578047-dfb367046420', alt: 'Gaming Setup' },
    //     { id: 5, src: 'https://images.unsplash.com/photo-1607853202273-797f1c22a38e', alt: 'Controller' },
    // ];

    // const middleColumnImages = [
    //     { id: 6, src: 'https://images.unsplash.com/photo-1547036967-23d11aacaee0', alt: 'Streaming' },
    //     { id: 7, src: 'https://images.unsplash.com/photo-1593508512255-86ab42a8e620', alt: 'Mobile Game' },
    //     { id: 8, src: 'https://images.unsplash.com/photo-1551103782-8ab07afd45c1', alt: 'Gaming PC' },
    //     { id: 9, src: 'https://images.unsplash.com/photo-1560253023-3ec5d502959f', alt: 'Arcade' },
    //     { id: 10, src: 'https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa', alt: 'Retro' },
    // ];

    // const rightColumnImages = [
    //     { id: 11, src: 'https://images.unsplash.com/photo-1600861195091-690c92f1d2cc', alt: 'FPS' },
    //     { id: 12, src: 'https://images.unsplash.com/photo-1542751371-adc38448a05e', alt: 'Esports' },
    //     { id: 13, src: 'https://images.unsplash.com/photo-1493711662062-fa541adb3fc8', alt: 'RPG' },
    //     { id: 14, src: 'https://images.unsplash.com/photo-1585771724684-38269d6639fd', alt: 'Strategy' },
    //     { id: 15, src: 'https://images.unsplash.com/photo-1511512578047-dfb367046420', alt: 'MMO' },
    // ];

    // const gamingClients = [
    //     { id: 1, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/41/Epic_Games_logo.png/800px-Epic_Games_logo.png', alt: 'Epic Games', width: 120, height: 40 },
    //     { id: 2, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Steam_icon_logo.svg/512px-Steam_icon_logo.svg.png', alt: 'Steam', width: 40, height: 40 },
    //     { id: 3, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Nintendo_Switch_Logo.svg/1200px-Nintendo_Switch_Logo.svg.png', alt: 'Nintendo', width: 120, height: 40 },
    //     { id: 4, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Xbox_logo_%282019%29.svg/1024px-Xbox_logo_%282019%29.svg.png', alt: 'Xbox', width: 80, height: 40 },
    //     { id: 5, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/PlayStation_logo.svg/1280px-PlayStation_logo.svg.png', alt: 'PlayStation', width: 120, height: 30 },
    //     { id: 6, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Riot_Games_logo.png/800px-Riot_Games_logo.png', alt: 'Riot Games', width: 100, height: 40 },
    //     { id: 7, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Ubisoft_logo.svg/1200px-Ubisoft_logo.svg.png', alt: 'Ubisoft', width: 120, height: 40 },
    //     { id: 8, src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Rockstar_Games_Logo.svg/1200px-Rockstar_Games_Logo.svg.png', alt: 'Rockstar', width: 120, height: 40 },
    // ];
    const leftColumnImages = [
        { id: 1, src: 'gamingbanner.webp', alt: 'Brand work 1' },
        { id: 2, src: 'gamingbanner1.webp', alt: 'Brand work 2' },
        { id: 3, src: 'gamingbanner4.webp', alt: 'Brand work 3' },
        { id: 4, src: 'gamingbanner1.webp', alt: 'Brand work 4' },
        { id: 5, src: 'gamingbanner2.webp', alt: 'Brand work 5' },
    ];

    const middleColumnImages = [
        { id: 8, src: 'gamingbanner3.webp', alt: 'Brand work 8' },
        { id: 9, src: 'gamingbanner5.webp', alt: 'Brand work 9' },
        { id: 10, src: 'gamingbanner7.webp', alt: 'Brand work 10' },
        { id: 11, src: 'gamingbanner3.webp', alt: 'Brand work 11' },
        { id: 12, src: 'gamingbanner5.webp', alt: 'Brand work 12' },
    ];

    const rightColumnImages = [
        { id: 13, src: 'gamingbanner4.webp', alt: 'Brand work 13' },
        { id: 14, src: 'gamingbanner7.webp', alt: 'Brand work 14' },
        { id: 15, src: 'gamingbanner8.webp', alt: 'Brand work 15' },
        { id: 6, src: 'gamingbanner6.webp', alt: 'Brand work 6' },
        { id: 7, src: 'gamingbanner7.webp', alt: 'Brand work 7' },
    ];

    return (
        <section className="relative  bg-gray-900 text-white">
            {/* Background image columns with gaming aesthetic */}
            <div className="absolute inset-0 z-0 flex gap-8 overflow-hidden">
                {/* Left column */}
                <div className="w-full md:-right-28 md:w-1/3  relative -top-16 h-[1000px]  -rotate-12 overflow-hidden opacity-70">
                    <div className="absolute gap-5 inset-0 flex flex-col animate-scroll-up">
                        {[...leftColumnImages, ...leftColumnImages].map((img, index) => (
                            <div key={`left-${img.id}-${index}`} className="h-1/3 flex-shrink-0">
                                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" loading="eager" />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Middle column */}
                <div className="hidden md:block w-1/3 md:-right-28 relative -top-16 h-[1000px]   -rotate-12 overflow-hidden opacity-70">
                    <div className="absolute inset-0 gap-5 flex flex-col animate-scroll-down h-full">
                        {[...middleColumnImages, ...middleColumnImages].map((img, index) => (
                            <div key={`middle-${img.id}-${index}`} className="h-1/3 flex-shrink-0">
                                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" loading="eager" />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right column */}
                <div className=" hidden md:block w-1/3 md:-right-28 relative -rotate-12 -top-16 h-[1000px]  overflow-hidden opacity-70">
                    <div className="absolute inset-0 gap-5 flex flex-col animate-scroll-up">
                        {[...rightColumnImages, ...rightColumnImages].map((img, index) => (
                            <div key={`right-${img.id}-${index}`} className="h-1/3 flex-shrink-0">
                                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" loading="eager" />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Neon gradient overlay */}
                {/* <div className="absolute inset-0 bg-gradient-to-b from-purple-900/30 via-blue-900/50 to-black/70" /> */}
                {/* Pixel grid overlay */}
                {/* <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/crisp-paper-ruffles.png')] opacity-10" /> */}
            </div>
            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70 z-0" />

            {/* Content */}
            <div className="relative z-10 container mx-auto px-4 py-20 md:py-32 lg:py-40">
                <div className="max-w-4xl mx-auto text-center">
                    <div className=" mt-10">
                        <h1 className="text-2xl md:text-3xl lg:text-4xl font-light mb-2 text-purple-300">Next-Level Game Development Studio</h1>
                        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 text-shadow bg-clip-text text-transparent bg-gradient-to-r from-purple-400 via-pink-500 to-blue-400">
                            Crafting Immersive Gaming Experiences
                        </h2>
                        <p className="text-lg md:text-xl text-gray-300">
                            Game Development • Esports Solutions • VR/AR Experiences • Game Porting
                        </p>
                    </div>

                    <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12 mt-12 md:mb-16">
                        <a
                            href="/quickenquiry"
                            className="inline-block bg-purple-600 hover:bg-purple-700 text-white px-8 py-3 rounded-full font-medium transition-colors duration-300 shadow-lg hover:shadow-purple-500/30"
                        >
                            Start Your Project
                            <span className="ml-2">🎮</span>
                        </a>

                    </div>


                </div>
            </div>


        </section>
    );
};

export default GamingHeroSection;